export default {"src":"/_next/static/media/chevdown.d64210c7.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};